import gsap from 'gsap';
import Sniffer from 'sniffer';
import SplitText from 'gsap/SplitText';
import { app } from './store';

class Effects {
  constructor() {
    this.el = document.querySelectorAll('[data-effect]');

    this.y = {
      current: 0,
    };

    this.total = 0;

    this.window = {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  init() {
    if (Sniffer.isDevice) return;

    if (this.el.length === 0) return;

    document.fonts.ready.then(() => {
      this.set();
    });

    this.on();
  }

  set = () => {
    const s = new SplitText(this.el, { type: 'lines' });

    gsap.set(s.lines, {
      opacity: 0,
      y: this.window.width * 0.05208,
    });
  }

  on() {
    gsap.ticker.add(this.inview);
  }

  off() {
    gsap.ticker.remove(this.inview);
  }

  inview = () => {
    if (Sniffer.isDevice) return;

    this.y.current = Math.abs(app.scroll.data.last);

    [...this.el].forEach((el) => {
      const i = el;
      const b = el.getBoundingClientRect();

      if (b.top < this.window.height / 1.5 && el.inview === undefined) {
        this.total += 1;
        i.inview = true;

        gsap.to(i.querySelectorAll('div'), {
          y: 0,
          opacity: 1,
          duration: 3,
          stagger: 0.05,
          ease: 'expo.out',
          clearProps: 'all',
        });
      }
    });

    if (this.total === this.el.length) {
      this.off();
    }
  }
}

export default Effects;
